import React from 'react';
import { useMediaQuery } from 'react-responsive';
import bgDyslexiaService from '../../../assets/images/educational_service/parralex_bg.jpg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function DyslexiaService() {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  return (
    <section className="relative z-10">
      <div
        className={`relative bg-cover bg-center bg-no-repeat ${
          isMobile ? '' : 'bg-fixed'
        } min-h-[800px] lg:min-h-[950px] flex items-center`}
        style={{ backgroundImage: `url(${bgDyslexiaService})` }}
      >
        <div className="relative z-10 w-full max-w-[1200px] mx-auto px-4 md:px-10 py-16 md:py-24 text-white">
          <h1 className="text-[34px] sm:text-[42px] md:text-[50px] font-bold leading-tight mb-6">
            Orton-Gillingham <br /> Dyslexia Services
          </h1>
          <div className="flex flex-col md:flex-row gap-10 xl:gap-32">
            <article className="flex-1 flex flex-col gap-4 text-[18px] md:text-[20px] xl:text-[22px] leading-8 font-[400]">
              <p className="font-semibold">
                Guidepost Pediatrics uses a variety of treatments and
                intervention strategies within our Speech and Educational
                Services Departments.
              </p>
              <p>
                Orton–Gillingham is a structured literacy approach. It
                introduced the idea of breaking reading and spelling down into
                smaller skills involving letters and sounds, and then building
                on these skills over time. The OG program also pioneered the
                multi-sensory approach to teaching reading, which is a common
                part of effective literacy programs. This means that instructors
                use sight, hearing, touch, and movement to help students connect
                language with letters and words. Orton–Gillingham is widely used
                to teach students with dyslexia.
              </p>
            </article>
            <motion.div
              initial={{ opacity: 0, x: isMobile ? 0 : 300 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1, ease: 'easeOut' }}
              viewport={{ once: true, amount: 0.5 }}
              className="flex-1 w-full flex flex-col gap-6 text-[18px] md:text-[20px] font-light px-0 relative"
            >
              <div className="relative w-full px-[24px] lg:px-6">
                <div className="absolute hidden lg:block -right-[990px] w-[1495px] bg-[#2B3990]/70 h-full top-0 z-0 rounded-s-2xl"></div>
                <article className="relative z-10 bg-[#2B3990]/70 lg:bg-transparent px-8 py-6 font-semibold xl:text-[22px] text-white rounded-2xl">
                  <p>
                    Orton–Gillingham is an award winning teaching approach that
                    was designed to help struggling readers. It explicitly
                    teaches the connections between letters and sounds. Many
                    effective reading programs include Orton–Gillingham
                    protocols.
                  </p>
                </article>
              </div>

              <p className="font-medium px-[58px]">
                Why is Orton-Gillingham the best program to address mixed
                receptive disorders for my child?
              </p>

              <div className="px-[58px]">
                <Link
                  to="/contact"
                  aria-label="Contact Guidepost about Dyslexia Services"
                  className="w-full md:w-[240px] inline-block border-2 border-white py-1 rounded-md text-white font-semibold text-lg transition-all duration-300 hover:bg-white hover:text-[#2B3990] hover:scale-105 text-center"
                >
                  Contact Us to Learn More
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DyslexiaService;
